
import SendContactImg from '../../Assets/images/SendContact-Us.png';
import SendContact from './SendContact';

const MakesLoanContact = () => {

  return (
    <div
      id="sendContact"
      className="w-full mx-auto md:py-8 py-6 md:px-20 px-4 md:-mb-20 -mb-4 bg-AboutUsBg lg:px-28 2xl:px-64 2xl:py-20"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        {/* Section One: Image, and Paragraph */}
        <div className="flex md:flex-col justify-center gap-2">
          <img
            src={SendContactImg}
            alt="TableImg"
            className="rounded-lg h-auto 2xl:w-80 md:w-64 w-36"
          />
          <p className="text-gray-600 md:mb-6 mb-0 text-xs md:text-sm pt-2 paragraph 2xl:text-lg">
            FinWise makes loan applications easy. Submit your form, connect with
            banks and corporations, and track your loan status effortlessly.
            Quick approvals and tailored solutions to help you reach your
            financial goals.
          </p>
        </div>
        {/* Section two: sendContact */}
        <div className="2xl:ml-96 lg:ml-64">
          <SendContact />
        </div>
      </div>
    </div>
  );
};

export default MakesLoanContact;
